module.exports = __webpack_public_path__ + "img/bigElectricMeter.5ab494d9.png";